import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { actionCreators as customersActions } from '../../../../../config/redux/customers/actions';
import CustomTextInput from '../../../../components/CustomTextInput';
import CustomButton from '../../../../components/CustomButton';

function FilterCustomersForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const dispatch = useDispatch();
  const commonProps = { errors, register };
  const onSubmit = data => dispatch(customersActions.getCustomers(data));
  const handleSeeAll = () => {
    dispatch(customersActions.getCustomers({ page: 1 }));
    reset();
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <CustomTextInput
          name={'id'}
          title={'CÉDULA'}
          {...commonProps}
          column="col-md-2"
        />
        <CustomTextInput
          name={'nombre'}
          title={'NOMBRE'}
          {...commonProps}
          column="col-md-2"
        />
      </div>
      <div>
        <CustomButton type={'submit'}>Filtrar</CustomButton>
        <CustomButton
          type={'button'}
          buttonStyle={'btn--outline'}
          onClick={handleSeeAll}>
          Ver todos
        </CustomButton>
      </div>
    </form>
  );
}

export default FilterCustomersForm;
